import React from 'react'
import PropTypes from 'prop-types'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import FormsyForm from 'formsy-react'
import { connect as connectStaticText } from '../StaticText/connect'
import Button, { TYPES } from '../Button/index'
import { getBoundActions } from '../../actions/index'
import { get as getConfig } from '../../config/index'
import { isBrowser } from '../../config/environment'
import { EmailInput, Checkbox } from '../FormInput.v2/index'
import {
  UPGRADE_NOW_URL, JOIN_NOW_URL, JOIN_NOW_QUERY,
  LIVE_CHANNEL_EMAIL_CAPTURE_KEY, EMAIL_CAPTURE_KEY_PREFIX,
} from '../../services/live-access-events/constants'
import { URL_PLAN_SELECTION } from '../../services/url/constants'
import { setLocalStorage, getLocalStorage } from '../../services/local-preferences/index'
import { FORM_INPUT_NAME_EMAIL_OPT_IN } from '../../services/form/index'
import { EMAIL_CAPTURED_GA4_EVENT } from '../../services/event-tracking/index'

const { appLang } = getConfig()

export const getEventEmailCaptureKey = (eventDetails) => {
  return EMAIL_CAPTURE_KEY_PREFIX + ((eventDetails)
    ? eventDetails.get('route', eventDetails.get('title', LIVE_CHANNEL_EMAIL_CAPTURE_KEY))
    : LIVE_CHANNEL_EMAIL_CAPTURE_KEY)
}

export const isEmailCaptured = (emailCaptureKey) => {
  return emailCaptureKey && isBrowser()
    ? getLocalStorage(emailCaptureKey) === 'yes' : true
}
class EmailCapture extends React.Component {
  constructor (props) {
    super(props)
    this.validEmail = this.validEmail.bind(this)
    this.inValidEmail = this.inValidEmail.bind(this)
    this.state = { validEmail: false }
  }

  onSelectOptInCheckbox = (name, checked) => {
    const { setEmailSignupOptin } = this.props

    setEmailSignupOptin(checked)
  }

  onValidSubmit = (model) => {
    const { props } = this
    const {
      doEmailSignup,
      setEventDefault,
      url,
      utm,
      language,
      emailCaptureKey,
      uid,
      auth,
      uiLocation,
    } = props
    const { email } = model
    const source = ''
    const fields = {
      registration_language: language,
      url,
      form_name: 'GAIA_STREAM_LIVE',
    }
    doEmailSignup(email, source, fields, utm)
    setLocalStorage(emailCaptureKey, 'yes', uid, auth)

    // GA4 event
    const emailCapturedEventData = EMAIL_CAPTURED_GA4_EVENT
      .mergeDeep({
        ui_location: uiLocation,
      })

    setEventDefault(emailCapturedEventData)
  }

  validEmail () {
    this.setState({ validEmail: true })
  }

  inValidEmail () {
    this.setState({ validEmail: false })
  }

  renderForm = () => {
    const { props, state } = this
    const { staticText, userEmail, emailSignup } = props
    const emailOptIn = emailSignup.get('optIn', false)
    const canSubmit = state.validEmail && !!emailSignup.get('optIn')

    return (
      <FormsyForm
        className="live-page-email-capture__form"
        onValidSubmit={this.onValidSubmit}
        onValid={this.validEmail}
        onInvalid={this.inValidEmail}
      >
        <EmailInput
          className={['live-page-email-capture__form__input']}
          label={staticText.getIn(['data', 'email'])}
          name="email"
          value={userEmail}
          validations="isEmail"
          validationError={staticText.getIn(['data', 'invalidEmail'])}
          required
        />
        <div className="live-page-email-capture__optin-container">
          <Checkbox
            onChange={this.onSelectOptInCheckbox}
            name={FORM_INPUT_NAME_EMAIL_OPT_IN}
            label={staticText.getIn(['data', 'optIn'])}
            value={emailOptIn}
            className="live-page-email-capture__optin"
            required
          />
        </div>
        <Button
          type={TYPES.PRIMARY}
          submit
          disabled={!canSubmit}
        >
          {staticText.getIn(['data', 'EmailSubmit'])}
        </Button>
      </FormsyForm>
    )
  }

  render () {
    const { props } = this
    const {
      staticText, emailCaptureKey, emailSignup, isAnonymous, path,
    } = props
    const isCaptured = isEmailCaptured(emailCaptureKey)
    if (isCaptured || emailSignup.get('success') === true) {
      return null
    }
    const isAMA = path === '/ama'
    const useLiveEmailCopy = path === '/live' || (isAMA && isAnonymous)
    const label1 = useLiveEmailCopy
      ? staticText.getIn(['data', 'EmailLabel1'])
      : staticText.getIn(['data', 'amaGateLine1'])
    const label2 = useLiveEmailCopy
      ? staticText.getIn(['data', 'EmailLabel2'])
      : staticText.getIn(['data', 'amaGateLine2'])
    const buttonText = isAnonymous ? staticText.getIn(['data', 'joinNow']) : staticText.getIn(['data', 'upgradeNow'])

    let url = UPGRADE_NOW_URL
    let query = null
    if (isAMA && !isAnonymous) {
      url = URL_PLAN_SELECTION
    } else if (isAnonymous) {
      url = JOIN_NOW_URL
      query = JOIN_NOW_QUERY
    }
    return (
      <div>
        <div className="live-page-email-capture__overlay live-page-email-capture__overlay--blocking">
          <div className="live-page-email-capture">
            <div className="live-page-email-capture__label">
              {label1}
            </div>
            {this.renderForm()}
            <div className="live-page-email-capture__label">
              {label2}
            </div>
            <Button
              type={TYPES.DEFAULT}
              url={url}
              query={query}
              className="live-page__email-capture__button button--imagery"
            >
              {buttonText}
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

EmailCapture.propTypes = {
  enforce: PropTypes.bool,
  setEmailSignupOptin: PropTypes.func.isRequired,
  setEventDefault: PropTypes.func,
}
EmailCapture.defaultProps = {
  enforce: false,
  uiLocation: 'Live Event',
}

export default compose(
  connectStaticText({ storeKey: 'livePage' }),
  connectRedux(
    (state) => {
      const language = state.user.getIn(['data', 'language', 0], appLang)
      return {
        auth: state.auth,
        uid: (state.auth) ? state.auth.get('uid') : -1,
        emailSignup: state.emailSignup,
        url: state.page.get('path'),
        utm: state.inboundTracking.getIn(['data', 'strings', 'utm']),
        language,
        emailCaptureKey: getEventEmailCaptureKey(state.liveAccessEvents.getIn(['eventDetails', language, 'data', 'event'])),
        isAnonymous: !state.auth.get('username'),
        userEmail: state.user.getIn(['data', 'mail']),
        path: state.resolver.get('path'),
      }
    },
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        doEmailSignup: actions.emailSignup.doEmailSignupBrooklyn,
        setEmailSignupOptin: actions.emailSignup.setEmailSignupOptin,
        setEventDefault: actions.eventTracking.setEventDefault,
      }
    },
  ),
)(EmailCapture)
